import { FC } from 'react';
import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% { background-position: -468px 0; }
  100% { background-position: 468px 0; }
`;

const SkeletonBlock = styled.div<{ height?: string; radius?: string }>`
  background: #f0f0f0;
  background-image: linear-gradient(
    to right,
    #f0f0f0 0%,
    #e8e8e8 20%,
    #f0f0f0 40%,
    #f0f0f0 100%
  );
  background-repeat: no-repeat;
  background-size: 800px 100%;
  display: inline-block;
  position: relative;
  animation: ${shimmer} 1.2s infinite linear;
  width: 100%;
  height: ${(p) => p.height || '16px'};
  border-radius: ${(p) => p.radius || '4px'};
`;

const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
  max-width: 600px;
  width: 100%;
  overflow: hidden;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
`;

const AvatarSkeleton = styled(SkeletonBlock)`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  flex-shrink: 0;
`;

const NameSkeleton = styled(SkeletonBlock)`
  width: 120px;
  margin-left: 10px;
`;

const MessageSkeleton = styled(SkeletonBlock)`
  width: 80%;
  margin: 0 16px 12px;
  height: 18px;
`;

const MediaSkeleton = styled(SkeletonBlock)`
  height: 300px;
  border-radius: 0;
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 16px;
  border-top: 1px solid #f0f0f0;
`;

const StatSkeleton = styled(SkeletonBlock)`
  width: 40px;
  height: 14px;
`;

const TimeSkeleton = styled(SkeletonBlock)`
  width: 80px;
  height: 14px;
`;

const FeedCardSkeleton: FC = () => {
  return (
    <Card>
      <Header>
        <AvatarSkeleton />
        <NameSkeleton />
      </Header>

      <MessageSkeleton />

      <MediaSkeleton />

      <Footer>
        <StatSkeleton />
        <TimeSkeleton />
      </Footer>
    </Card>
  );
};

export default FeedCardSkeleton;
